<template>
  <v-container grid-list-md fluid align-baseline pa-0>
  <v-layout row wrap>

    <v-snackbar
        v-model="mainSnackbar"
    >
        {{mainSnackbarText}}
        <v-btn
            color="pink"
            flat
            @click="closeMainSnackBar"
        >
            Close
        </v-btn>                            
    </v-snackbar>  
    
    <v-flex xs12>
        <v-dialog
            v-model="dialogCreateChat"            
            pa-0
            fullscreen
            v-show="dialogCreateChat"
            >

            <v-card v-if="addChatDoc">
                <v-toolbar dark color="primary">
                    <v-toolbar-side-icon @click="closeDialogCreateChat">
                    <v-icon>close</v-icon>
                                                    
                    </v-toolbar-side-icon>
                    <v-toolbar-title>Create a Group Conversation</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>                        


                <v-card-text>
                <v-form v-model="validNewChat">
                    <v-flex xs12>

                        <v-layout column>
                            <v-flex>
                                <v-layout pt-2 row>
                                    <v-flex ml-3 class="font-weight-bold flexlabel" xs3>
                                        Chat Name:
                                    </v-flex>
                                    <v-flex class="flexvalue caption" ml-2 xs9>
                                        <v-text-field
                                            v-model="addChatDoc.chatname"
                                            placeholder="e.g. Anniv Planning Group Chat"
                                            required                                    
                                            :rules="textfieldRules"
                                        ></v-text-field>  
                                    </v-flex>                      
                                </v-layout>
                            </v-flex>
                            <v-divider></v-divider>
                        </v-layout>    
                        <v-layout column>
                            <v-flex>
                                <v-layout pt-2 row>
                                    <v-flex ml-3 class="font-weight-bold flexlabel" xs3>
                                        Participants:
                                    </v-flex>
                                    <v-flex class="flexvalue caption" ml-2 xs9>
                                        <v-autocomplete
                                        :items="allMembers.filter(m=>{return m.userid!==undefined && m.userid!==null && m.userid!==member.userid})"
                                        v-model="addChatDoc.participantsObjs"                                    
                                        label="Choose Participants"
                                        multiple
                                        chips
                                        small
                                        bottom
                                        prepend-icon="people"
                                        required 
                                        :rules="dropdownRules"
                                        >
                                        <template  slot="item" slot-scope="data">                
                                            <span v-if="data.item" class="caption" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
                                        </template>    
                                        <template  slot="selection" slot-scope="data">   
                                            <v-chip
                                            :selected="data.selected"
                                            close
                                            small
                                            dark
                                            color="primary lighten-4"
                                            class="chip--select-multi"
                                            @input="data.parent.selectItem(data.item)"
                                            >                                                     
                                        {{ data.item.firstname }} {{ data.item.lastname }}
                                            </v-chip>
                                        </template>                  
                                                
                                        </v-autocomplete> 
                                    </v-flex>                      
                                </v-layout>
                            </v-flex>
                            <v-divider></v-divider>
                        </v-layout>    
                    </v-flex>
                </v-form>              
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right xs6>                        
                    </v-flex>
                    <v-flex text-xs-right xs4>   
                    <v-btn dark color="primary lighten-2" :disabled="!validNewChat" @click="createChat()"> Create Chat               
                    <v-icon>chevron_right</v-icon>
                    </v-btn>
                    </v-flex>
                    <v-flex text-xs-right xs2>                        
                    </v-flex>                    
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-flex>


    <v-flex xs12>
        <v-dialog
            v-model="dialogViewChat"
            fullscreen
            pa-0
            v-show="dialogViewChat"
            >
                   <v-card
                        v-if="currChatDoc"
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="closeDialogViewChat">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title v-if="currChatDoc.islinechat">View Chat: {{memberline.lineseason}} {{memberline.lineyear}} </v-toolbar-title>
                            <v-toolbar-title v-else>View Chat: {{currChatDoc.chatname}} </v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar>                        

                        <v-snackbar
                            v-model="snackbar"
                        >
                            {{snackbarText}}
                            <v-btn
                                color="pink"
                                flat
                                @click="closeSnackBar"
                            >
                                Close
                            </v-btn>                            
                        </v-snackbar>



                        <v-card-title>
                            <v-icon>people</v-icon>
                            <div v-if="currChatDoc.islinechat" class="headline pa-1">Line Chat: {{memberline.linename}} </div>
                            <div v-else class="headline pa-1">Group Chat: {{currChatDoc.chatname}} </div>
                            
                        </v-card-title>                        
                        <v-card-text>            


                        <v-card v-if="currChatDoc.islinechat">
                            <v-card-text>

                            <v-flex xs12>
                            <v-list>
                                <template v-for="mbr in memberline.linemembers">
                                <v-list-tile v-bind:key="`vlisttile-${mbr.lastname + mbr.firstname}`">
                                    <v-layout row>
                                    <v-flex xs3 class="profilekey caption font-weight-bold">
                                        Participant:
                                    </v-flex>
                                    <v-flex class="profilevalue caption" xs9>
                                        {{mbr.firstname}} {{mbr.lastname}}
                                    </v-flex>  
                                                        
                                    </v-layout>
                                </v-list-tile>
                                <v-divider inset v-bind:key="`vdividera-${mbr.lastname + mbr.firstname}`"></v-divider>  
                                </template>    
                            </v-list>
                            </v-flex>
<!--                            
                            <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                                <template v-for="mbr in memberline.linemembers">
                                <v-layout v-bind:key="`vlayouta-${mbr.lastname + mbr.firstname}`" row align-space-between justify-start >
                                    <v-flex pa-0 xs3 class="fieldlabel">
                                        <v-card flat tile><v-card-text>
                                            <span>Participant:</span>
                                        </v-card-text></v-card>
                                    </v-flex>
                                    <v-flex xs10 class="fieldvalue subheading">
                                        <v-card flat tile><v-card-text>{{mbr.firstname}} {{mbr.lastname}}</v-card-text></v-card>
                                    </v-flex>
                                </v-layout>
                                <v-divider v-bind:key="`vdividera-${mbr.lastname + mbr.firstname}`" ></v-divider>                                
                                </template>
                            </v-container>
-->

                            </v-card-text>
                        </v-card>

                        <v-card v-else>
                            <v-card-text>

                            <v-flex xs12>
                            <v-list>
                                <v-list-tile>
                                    <v-layout row>
                                    <v-flex xs3 class="profilekey caption font-weight-bold">
                                        Chat Owner:
                                    </v-flex>
                                    <v-flex class="profilevalue caption" xs9 >
                                        {{currChatDoc.ownername}}
                                    </v-flex>  
                                                        
                                    </v-layout>
                                </v-list-tile>
                                <v-divider inset></v-divider>  

                                <template v-for="pname in currChatDoc.participantnames">
                                <v-list-tile v-bind:key="`vlisttileb-${pname.replace(/\s/g,'')}`">
                                    <v-layout row>
                                    <v-flex xs3 class="profilekey caption font-weight-bold">
                                        Participant:
                                    </v-flex>
                                    <v-flex class="profilevalue caption" xs9 >
                                        <v-layout row wrap>
                                            <v-flex xs11>
                                        {{pname}}
                                            </v-flex>
                                            <v-flex xs1>
                                        <div @click="promptDeleteParticipant(pname)" v-if="member.userid===currChatDoc.ownerid" class="caption primary--text" ><v-icon small color="primary" class="pr-1">far fa-trash-alt</v-icon> </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>  
                                                        
                                    </v-layout>
                                </v-list-tile>
                                <v-divider inset v-bind:key="`vdividerb-${pname.replace(/\s/g,'')}`"></v-divider>  
                                </template>    
                            </v-list>
                            <div @click="promptAddParticipants()" v-if="member.userid===currChatDoc.ownerid" class="caption primary--text" ><v-icon small color="primary" class="pr-1">fas fa-user-plus</v-icon> Add Participants</div>
                            <v-dialog
                            v-model="dialogDeleteParticipant"                            
                            pa-0
                            >
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                        Are you sure you want to remove <span class="primary--text"> {{deleteParticipantName}} </span> from this chat?
                                            </v-flex>
                                            <v-flex xs12>
                                        <v-btn flat small dark color="primary" @click="dialogDeleteParticipant=false">Cancel</v-btn>
                                        <v-btn small dark color="primary" @click="deleteParticipant()">Yes, Remove</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>   

                            <v-dialog
                            v-model="dialogAddParticipants"                            
                            pa-0
                            >
                                <v-card>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                        Select participants to add to this chat?
                                            </v-flex>
                                            <v-flex xs12>  
                                                <v-autocomplete
                                                :items="allMembers.filter(m=>{return m.userid!==undefined && m.userid!==null && m.userid!==member.userid && currChatDoc.participants.includes(m.userid)===false})"
                                                v-model="addParticipants"                                    
                                                label="Choose Participants"
                                                multiple
                                                chips
                                                small
                                                bottom
                                                prepend-icon="people"
                                                required 
                                                :rules="dropdownRules"
                                                >
                                                <template  slot="item" slot-scope="data">                
                                                    <span v-if="data.item" class="caption" style="width:200px;">{{ data.item.firstname }} {{ data.item.lastname }} </span> <span v-if="data.item" style="color:blue;"> {{ data.item.lineid }}</span> 
                                                </template>    
                                                <template  slot="selection" slot-scope="data">   
                                                    <v-chip
                                                    :selected="data.selected"
                                                    close
                                                    small
                                                    dark
                                                    color="primary lighten-4"
                                                    class="chip--select-multi"
                                                    @input="data.parent.selectItem(data.item)"
                                                    >                                                     
                                                        {{ data.item.firstname }} {{ data.item.lastname }}
                                                    </v-chip>
                                                </template>                  
                                                        
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>      
                                                <v-btn flat small dark color="primary" @click="dialogAddParticipants=false">Cancel</v-btn>                                  
                                                <v-btn small dark color="primary" @click="addNewParticipants()">Add</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>                                                     
                            </v-flex>
<!--                                                            
                            <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                                <v-layout row  align-space-between justify-start >
                                    <v-flex pa-0 xs3 class="fieldlabel">
                                        <v-card flat tile><v-card-text>
                                            <span>Chat Owner:</span>
                                        </v-card-text></v-card>
                                    </v-flex>
                                    <v-flex xs10 class="fieldvalue subheading">
                                        <v-card flat tile ><v-card-text>{{currChatDoc.ownername}}</v-card-text></v-card>
                                    </v-flex>
                                </v-layout>
                                <v-divider  ></v-divider>                                
                                <template v-for="pname in currChatDoc.participantnames">
                                <v-layout v-bind:key="`vlayoutb-${pname.replace(/\s/g,'')}`" row align-space-between justify-start >
                                    <v-flex pa-0 xs3 class="fieldlabel">
                                        <v-card flat tile><v-card-text>
                                            <span>Participant:</span>
                                        </v-card-text></v-card>
                                    </v-flex>
                                    <v-flex xs10 class="fieldvalue subheading">
                                        <v-card flat tile><v-card-text>{{pname}}</v-card-text></v-card>
                                    </v-flex>
                                </v-layout>
                                <v-divider v-bind:key="`vdividerb-${pname.replace(/\s/g,'')}`" ></v-divider>                                
                                </template>
                            </v-container>
-->                            
                            </v-card-text>
                        </v-card>
            <template v-if="currChatDoc">
                <!-- ====== BEGIN TASK SECTION  ========-->
                <v-card flat class="pt-3 pb-3">
                    <v-expansion-panel >
                        <v-expansion-panel-content
                            key="tasks"
                        >
                        <div slot="header" class="body font-weight-bold primary--text">
                            <v-icon color="primary" class="pr-1">fas fa-tasks</v-icon> View/Edit Task List (i.e. ToDos)
                        </div>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs6>
                        <v-text-field
                            class="caption"
                            v-model="newTaskText"
                            box
                            placeholder="Enter a new task"
                        >
                        </v-text-field>
                            </v-flex>                            
                            <v-flex xs5>
                                <v-select 
                                v-if="currChatDoc.islinechat"                          
                                :items="memberline.linemembers.map(lm=>{return lm.firstname + ' ' + lm.lastname})"
                                box
                                label="Assign Task"
                                hint="Assign Task"
                                class="pl-3 caption"
                                v-model="newTaskAssignment"
                                ></v-select>    

                                <v-select 
                                v-else                            
                                :items="currChatDoc.participantnames"
                                box
                                label="Assign Task"
                                class="pl-3 caption"
                                v-model="newTaskAssignment"
                                ></v-select>                                
                            </v-flex>

                            <v-flex xs1 pl-2>
                                <v-icon @click="addTask" color="primary" large>fas fa-plus-square</v-icon>
                            </v-flex>


                        </v-layout>
                    </v-card-title>
                    <v-card-text >
                        <v-layout row wrap class="pl-4 pr-4">
                            <v-flex xs1 class="font-weight-bold">
                                
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold">
                                <u>Task</u>
                            </v-flex>                            
                            <v-flex xs3 class="font-weight-bold">
                                <u>Assigned To</u>
                            </v-flex>
                        </v-layout>                        
                        <v-expansion-panel v-for="(t,tIndex) in currChatDoc.tasks" v-bind:key="'task-' + tIndex">
                            <v-expansion-panel-content
                                key="tasks"
                            >
                            <div slot="header" class="caption">
                                <v-layout row wrap>
                                     <v-flex xs1>
                                         <v-icon v-if="t.iscomplete===false && t.assignedto===member.firstname + ' ' + member.lastname" @click="toggleTaskStatus(t,true)" color="primary">far fa-square</v-icon>
                                         <v-icon v-else-if="t.iscomplete===true  && t.assignedto===member.firstname + ' ' + member.lastname" @click="toggleTaskStatus(t,false)" color="primary" >fas fa-check-square</v-icon>
                                         <v-icon v-else-if="t.iscomplete===false && t.assignedto!==member.firstname + ' ' + member.lastname"  color="grey">far fa-square</v-icon>
                                         <v-icon v-else-if="t.iscomplete===true  && t.assignedto!==member.firstname + ' ' + member.lastname"  color="grey" >fas fa-check-square</v-icon>                                         
                                     </v-flex>
                                    <v-flex xs8 class="pl-1">
                                    <span v-if="t.iscomplete===true" style="text-decoration: line-through;">{{t.tasktext}}</span>
                                    <span v-else>{{t.tasktext}}</span>
                                    </v-flex>
                                    <v-flex xs3 class="pl-3">
                                        {{t.assignedto}}
                                    </v-flex>
                                  
                                </v-layout>
                            </div>
                            <div style="background-color:#F0F0F0;" class="caption">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-layout column>
                                            <v-flex pb-2>
                                                Date Created: {{t.datecreated}}
                                            </v-flex>
                                            <v-divider></v-divider>
                                            <v-flex pb-2>
                                                Created By: {{t.createdby}}
                                            </v-flex>
                                            <v-divider></v-divider>                                            
                                            <v-flex pb-2 v-if="t.laststatusdate">
                                                Status Date: {{t.laststatusdate}}
                                            </v-flex>
                                            <v-divider></v-divider>
                                            <template v-for="(c,cIndex) in t.comments">
                                            <v-flex pb-2 v-bind:key="'vflex-comment-' + cIndex">
                                                Comment: {{c.comment}} **{{c.authorname}} {{c.datecreated}}
                                            </v-flex> 
                                            <v-divider v-bind:key="'vdividercomment-' + cIndex"></v-divider> 
                                            </template>    
                                            <v-flex pb-2 v-if="t.iscomplete===false">
                                                <v-layout row wrap>
                                                    <v-flex xs10>
                                                        <v-text-field
                                                            class="caption"
                                                            placeholder="Add a new comment "
                                                            solo     
                                                            v-model="newTaskComment"                                                   
                                                        >

                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <v-icon class="pl-1 pt-1" @click="addTaskComment(t)" color="primary">send</v-icon>
                                                    </v-flex>
                                                </v-layout>                                                
                                            </v-flex>                                                                                                                                                                                                                      
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-card-text>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-card>


                <!-- ====== END TASK SECTION  ========-->
            </template>
            <template v-if="currChatDoc">
                    <div v-if="currChatDoc.islinechat" class="subheading font-weight-medium pa-3">Send a Line Chat Message:</div>
                    <div v-if="currChatDoc.isgroupchat" class="subheading font-weight-medium pa-3">Send a Group Chat Message:</div>
                    <v-card flat>
                        <v-card-text>
                            <v-layout>
                            <v-flex xs12>
                            <v-textarea
                                v-model="messagetext"
                                label="Message"
                                placeholder="Type message here."
                                auto-grow
                                outline
                                height=20
                                append-outer-icon="send"
                                :append-outer-icon-cb = "addMessage"
                            ></v-textarea>

                            <v-card-actions>
                                
                                <div class='caption'></div>
                            </v-card-actions>   
                            </v-flex>       
                            </v-layout>
                        </v-card-text>
 
                    </v-card>
            </template>               
            <template v-if="currChatDoc">
                    <div class="subheading font-weight-medium pa-3">Messages:</div>

                    <v-card>
                        <v-card-text v-if="currChatDoc.messages">
                            <template v-for="(m,index) in currChatDoc.messages" class="postComments">
                                    <v-layout v-bind:key="`vlayouta-${m.datecreated}${index}`" row wrap>
                                    <v-flex v-if="m.authorid === member.userid" v-bind:key="`vflex-me-padding-${m.datecreated}`" xs2 pa-3>
                                    </v-flex>
                                    <v-flex v-bind:key="`vflexa-${m.datecreated}${index}`" xs10 pa-3>
                                        <div v-if="m.authorid !== member.userid" v-bind:key="`msgcard-${m.datecreated}`" class="chat-card-me">                                        
                                            <v-flex xs12>
                                                                                 
                                            <div v-bind:key="`msgcontenta-${m.datecreated}${index}`" class="caption pa-2 lighten-2">{{m.content}}<br/><br/></div>
                                            </v-flex>
                                        </div>

                                        <div v-else v-bind:key="`msgcarda-${m.datecreated}${index}`" class="chat-card">                                        
                                            <v-flex xs12>
                                            <div v-bind:key="`msgcontenta-${m.datecreated}${index}`" class="caption pa-2 lighten-2">{{m.content}}<br/><br/></div>
                                            </v-flex>
                                        </div>                                        
                                        <v-flex v-if="m.authorid === member.userid" class="chat-card-me-date caption" xs12 align-content-start justify-start>                                            
                                            <template >                                                
                                                <v-icon>person</v-icon><b>{{m.authorname}}</b>                                         
                                                {{m.datecreated}}
                                            </template>                                            
                                        </v-flex>
                                        <v-flex v-else class="chat-card-date caption" xs12 align-content-end justify-end>                                            
                                            <template >                                                
                                                <v-icon>person</v-icon><b>{{m.authorname}}</b>                                         
                                                {{m.datecreated}}
                                            </template>                                            
                                        </v-flex>                                        
                                    </v-flex>
                                    </v-layout>
                            </template>
                        </v-card-text>    
                        <v-card-text v-else>
                                <span class="body-1">no messages in chat {{currChatDoc.chatname}} </span>
                        </v-card-text>
                            
                        </v-card>
            </template>
 


                        </v-card-text>

                   </v-card>
 



            </v-dialog>
    </v-flex>


    <v-flex xs12 pa-3>


        <div class="font-weight-medium title pa-1">Active Conversations </div>
        <v-subheader>My Line Chat</v-subheader>
            <v-btn
              color="accent "
              dark
              absolute
              top
              right
              fab
              @click="openDialogCreateChat"
            >
              <v-icon>add</v-icon>
            </v-btn>        
    <v-flex xs12>
        <v-card raised class="convo-card" >     


            <v-card-text >
                <div class="font-weight-medium subheading pa-1"><v-icon>people</v-icon> Your Line Chat </div>
                <div class="font-weight-medium body-2 pa-1">{{memberline.lineseason}} {{memberline.lineyear}}: {{memberline.linename}}</div>
                <div class="font-weight-medium body-2 pa-2">
                    <template v-if="lineMessagesDocs[0].messages.length>0">
                        <div class="caption" >Latest Message: {{lineMessagesDocs[0].datelastmessage}}</div>
                        <div class="caption">From: {{lineMessagesDocs[0].lastmessageauthorname}}</div>
                        <v-divider></v-divider>
                        <div class="pa-3 primary--text text--darken-2" >{{text_truncate(lineMessagesDocs[0].lastmessage)}}</div>

                    </template>
                    <template v-else>
                        <div>There are currently no messages in this chat thread.</div>
                    </template>
                </div>
            </v-card-text>
            <v-card-actions>
                
                <v-flex text-xs-right xs6>
                    
                </v-flex>
                <v-flex text-xs-right xs4>   
                <v-btn dark color="primary lighten-2" @click="viewChat(lineMessagesDocs[0])"> View Chat                
                <v-icon>chevron_right</v-icon>
                </v-btn>
                </v-flex>
                <v-flex text-xs-right xs2>                        
                </v-flex>                  
            </v-card-actions>
        </v-card>
    </v-flex>
    <v-subheader>Group Chats (owned by me)</v-subheader>
    <template v-for="(gomds, index) in groupOwnerMessagesDocs">
        <v-flex xs12  v-bind:key="`v-flex-gomds-${gomds.chatid}`">
            <v-card  raised class="convo-card" v-bind:key="`v-card-gomds-${gomds.chatid}`">
                <v-card-text >
                    <div class="font-weight-medium subheading pa-1"><v-icon>people</v-icon> {{gomds.chatname}} </div>
                    <div class="font-weight-medium body-2 pa-1"></div>
                    <div class="font-weight-medium body-2 pa-2">
                        <template v-if="gomds.messages.length>0">
                            <div class="caption" >Latest Message: {{gomds.datelastmessage}}</div>
                            <div class="caption">From: {{gomds.lastmessageauthorname}}</div>
                            <v-divider></v-divider>
                            <div class="pa-3  primary--text text--darken-2">{{text_truncate(gomds.lastmessage)}}</div>

                        </template>
                        <template v-else>
                            <div>There are currently no messages in this chat thread.</div>
                        </template>
                    </div>
                </v-card-text>
                <v-card-actions>
            
                    <v-flex text-xs-right xs6>
                        
                    </v-flex>
                    <v-flex text-xs-right xs4>   
                    <v-btn dark color="primary lighten-2" @click="viewChat(groupOwnerMessagesDocs[index])"> View Chat                
                    <v-icon>chevron_right</v-icon>
                    </v-btn>
                    </v-flex>
                    <v-flex text-xs-right xs2>                        
                    </v-flex>                  
                </v-card-actions>
            </v-card>        
        </v-flex>    
    </template>
   <v-subheader>Group Chats (participating)</v-subheader>
    <template v-for="gmds in groupMessagesDocs">
        <v-flex xs12  v-bind:key="`v-flex-gmds-${gmds.chatid}`">
            <v-card  raised class="convo-card" v-bind:key="`v-card-gmds-${gmds.chatid}`">
                <v-card-text >
                    <div class="font-weight-medium subheading pa-1"><v-icon>people</v-icon> {{gmds.chatname}} </div>
                    <div class="font-weight-medium body-2 pa-1"></div>
                    <div class="font-weight-medium body-2 pa-2">
                        <template v-if="gmds.messages.length>0">
                            <div class="caption" >Latest Message: {{gmds.datelastmessage}}</div>
                            <div class="caption">From: {{gmds.lastmessageauthorname}}</div>
                            <v-divider></v-divider>
                            <div class="pa-3  primary--text text--darken-2" >{{text_truncate(gmds.lastmessage)}}</div>

                        </template>
                        <template v-else>
                            <div>There are currently no messages in this chat thread.</div>
                        </template>
                    </div>
                </v-card-text>
                <v-card-actions>
            
                    <v-flex text-xs-right xs6>
                        
                    </v-flex>
                    <v-flex text-xs-right xs4>   
                    <v-btn dark color="primary lighten-2" @click="viewChat(gmds)"> View Chat                
                    <v-icon>chevron_right</v-icon>
                    </v-btn>
                    </v-flex>
                    <v-flex text-xs-right xs2>                        
                    </v-flex>                  
                </v-card-actions>
            </v-card>        
        </v-flex>    
    </template>

   <v-subheader>Active Private Chats </v-subheader>
    <template v-for="mmds in memberMessagesDocs">
        <v-flex xs12  v-bind:key="`v-flex-mmds-${mmds.chatid}`">
            <v-card  raised class="convo-card" v-bind:key="`v-card-mmds-${mmds.chatid}`">
                <v-card-text >
                    <div class="font-weight-medium subheading pa-1"><v-icon>people</v-icon> {{mmds.chatname}} </div>
                    <div class="font-weight-medium body-2 pa-1"></div>
                    <div class="font-weight-medium body-2 pa-2">
                        <template v-if="mmds.messages.length>0">
                            <div class="caption" >Latest Message: {{mmds.datelastmessage}}</div>
                            <div class="caption">From: {{mmds.lastmessageauthorname}}</div>
                            <v-divider></v-divider>
                            <div class="pa-3  primary--text text--darken-2" >{{text_truncate(mmds.lastmessage)}}</div>

                        </template>
                        <template v-else>
                            <div>There are currently no messages in this chat thread.</div>
                        </template>
                    </div>
                </v-card-text>
                <v-card-actions>
            
                    <v-flex text-xs-right xs6>
                        
                    </v-flex>
                    <v-flex text-xs-right xs4>   
                    <v-btn dark color="primary lighten-2" @click="viewChat(mmds)"> View Chat                
                    <v-icon>chevron_right</v-icon>
                    </v-btn>
                    </v-flex>
                    <v-flex text-xs-right xs2>                        
                    </v-flex>                  
                </v-card-actions>
            </v-card>        
        </v-flex>    
    </template>

    </v-flex>

  </v-layout>
  </v-container>
</template>

<script>
  import firebase from 'firebase'
 import moment from 'moment'

const DATEFORMAT = "YYYY-MM-DD"

  export default {
    data () {
        return {       
            validNewChat: false,
            textareaRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 10) || 'Field must be greater than 10 characters'
            ],            
            textfieldRules: [
                v => !!v || 'Field is required',
                v => (v && v.length >= 5) || 'Field must be greater than 5 characters'
            ],
            dropdownRules: [
                v => (!!v && v.length>0)|| 'Field is required'
            ],                    
            dialogViewChat: false,
            dialogCreateChat: false,
            snackbar: false,
            snackbarText: null,
            mainSnackbar: false,
            mainSnackbarText: null,            
            messagetext: null,
            chatid: null,
            chatparticipants: [],
            chatparticipantnames: [],
            chatname: null,
            chatownerid: null,
            currChatDoc: null,
            addChatDoc: null,
            newTaskText: null,
            newTaskAssignment: null,
            newTaskComment: null,
            dialogDeleteParticipant: false,
            deleteParticipantName: null,
            deleteParticipantIds: null,
            dialogAddParticipants: false,
            addParticipants: null,
            addParticipantNames: null,
            addParticipantIds: null
        }
    },
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
        
        
        
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      allMembers () {
          return this.$store.getters.allMembers
      },
      sortedLinesAndMembers () {
          return this.$store.getters.sortedLinesAndMembers
      },
      messagesdocTemplate () {
        return this.$store.getters.messagesdocTemplate
      },      
      memberMessagesDocs () {
        return this.$store.getters.memberMessagesDocs
      },
      lineMessagesDocs () {
        return this.$store.getters.lineMessagesDocs
      },
      groupOwnerMessagesDocs () {
        return this.$store.getters.groupOwnerMessagesDocs
      },
      groupMessagesDocs () {
        return this.$store.getters.groupMessagesDocs
      },
      memberline () {
          var memberlineid = this.$store.getters.member.lineid
        var objmemberline = this.sortedLinesAndMembers.filter(function (obj){
            return obj.lineid === memberlineid
        })  
        //console.log("conversations.vue member watch objmemberline=",objmemberline)
        if(objmemberline.length>0){
            return objmemberline[0]
        }else{
            return null
        }        
            

      }     
              
    },
    watch: {
        lineMessagesDocs(value){
            if(this.currChatDoc && this.currChatDoc.islinechat){
                this.currChatDoc = value[0]
            }
        },
        groupMessagesDocs(value){
            if(this.currChatDoc && this.currChatDoc.isgroupchat){
                //console.log('this.currChatDoc before ',this.currChatDoc)
                //console.log('this.currChatDoc groupMessagesDocs value ',value)
                var updatedChatDoc = value.find(d=>{
                    return d.chatid === this.currChatDoc.chatid
                }) 
                if(updatedChatDoc){
                    this.currChatDoc = updatedChatDoc
                }
            //console.log('this.currChatDoc after',this.currChatDoc)
            }
        },
        groupOwnerMessagesDocs(value){
            if(this.currChatDoc && this.currChatDoc.isgroupchat){
                //console.log('this.currChatDoc before ',this.currChatDoc)
                //console.log('this.currChatDoc groupOwnerMessagesDocs value ',value)
                var updatedChatDoc = value.find(d=>{
                    return d.chatid === this.currChatDoc.chatid
                }) 
                if(updatedChatDoc){
                    this.currChatDoc = updatedChatDoc
                }
            //console.log('this.currChatDoc after',this.currChatDoc)
            }
        }        
    },
    methods: {
        viewChat: function (chatDoc){
            this.currChatDoc = chatDoc
            this.openDialogViewChat()
        },
        createChat: function (){
            if(this.validNewChat===false){
                this.snackbarText = 'Please fill out the required fields'
                this.openSnackBar()
            }else{
                var dt = new Date();
                var tmpdatemodified = dt.getTime()  
                var tmpAddChatDoc = this.addChatDoc
                //tmpAddChatDoc.chatid = tmpAddChatDoc.org + '_' + tmpAddChatDoc.chapter + '_chat_group_' + tmpAddChatDoc.ownerid + '_' + tmpdatemodified

                tmpAddChatDoc.chatid = 'chat_group/' + tmpAddChatDoc.chapter + '/' + tmpAddChatDoc.ownerid + '_' + tmpdatemodified

                //console.log('createChat tmpAddChatDoc.participantsObjs',tmpAddChatDoc.participantsObjs )
                if(!tmpAddChatDoc.participants){
                    tmpAddChatDoc.participants = new Array()
                }
                if(!tmpAddChatDoc.participantnames){
                    tmpAddChatDoc.participantnames = new Array()
                }            
                for(var i=0; i<tmpAddChatDoc.participantsObjs.length; i++){
                    var tmpparticipantuserid = tmpAddChatDoc.participantsObjs[i].userid
                    var tmpparticipantname = tmpAddChatDoc.participantsObjs[i].firstname + ' ' + tmpAddChatDoc.participantsObjs[i].lastname
                    if(tmpparticipantuserid){ //only registered users (members) will have userids
                        tmpAddChatDoc.participants.push(tmpparticipantuserid) //add userid to participants array
                        tmpAddChatDoc[tmpparticipantuserid] = true //add userid <value> equal to true to message doc (makes querying easier)
                        if(tmpparticipantname){
                            tmpAddChatDoc.participantnames.push(tmpparticipantname)
                        }                    
                    }

                }
                tmpAddChatDoc.tasks = []
                //ADD THE INITIAL MESSAGE: addMessage
                tmpAddChatDoc.messages = new Array()
                var initialmessage = new Object()
                initialmessage.datecreated = tmpdatemodified
                initialmessage.authorid = tmpAddChatDoc.ownerid
                initialmessage.authorname = tmpAddChatDoc.ownername
                initialmessage.authorline = tmpAddChatDoc.ownerline
                initialmessage.authoravatar = this.$store.getters.user.photoUrl
                if(this.$store.getters.member.profilepic && this.$store.getters.member.profilepic.fileurl){
                    initialmessage.authoravatar = this.$store.getters.member.profilepic.fileurl
                }
                initialmessage.content = 'Welcome to the chat "' + tmpAddChatDoc.chatname + '", created by ' + tmpAddChatDoc.ownername + ' - ' + tmpAddChatDoc.ownerline

                tmpAddChatDoc.messages.push(initialmessage)

                tmpAddChatDoc.datelastmessage = initialmessage.datecreated
                tmpAddChatDoc.lastmessage = initialmessage.content
                tmpAddChatDoc.lastmessageauthorname = initialmessage.authorname

                delete tmpAddChatDoc.participantsObjs

                //CREATE THE CHAT DOC / CLOSE THE DIALOG
                this.$store.dispatch('addGroupMessage', tmpAddChatDoc).then(errmsg => {
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('addGroupMessage', errmsg) 
                    this.closeDialogCreateChat()
                    this.mainSnackbarText="Failed to create convo."
                    this.openMainSnackBar()
                }else{
                    //console.log('successfully added message') 
                    this.closeDialogCreateChat()
                    this.mainSnackbarText="Convo successfully created."                
                    this.openMainSnackBar()
                }
                })   
            }
                      
            
        },        
        openDialogViewChat: function (){
            this.dialogViewChat = true
        },
        closeDialogViewChat: function (){
            this.dialogViewChat = false
            this.memberProfileView = this.memberProfileViewTemplate
            this.messagetext=''
        },
        openDialogCreateChat: function (){
            var tmpobjmemberline = this.memberline            
            this.addChatDoc = this.messagesdocTemplate
            this.addChatDoc.isgroupchat = true
            this.addChatDoc.chapter = this.member.chapter
            this.addChatDoc.org = this.member.org
            this.addChatDoc.ownerid = this.member.userid
            this.addChatDoc[this.member.userid] = true
            this.addChatDoc.ownername = this.member.firstname + ' ' + this.member.lastname
            this.addChatDoc.ownerline = tmpobjmemberline.lineseason + ' ' + tmpobjmemberline.lineyear
            this.addChatDoc.owneravatar = this.$store.getters.user.photoUrl
            if(this.member.profilepic && this.member.profilepic.fileurl){
                this.addChatDoc.owneravatar  = this.member.profilepic.fileurl
            }
            this.addChatDoc.participantsObjs = []
            //console.log('openDialogCreateChat -> addChatDoc', this.addChatDoc)
            this.dialogCreateChat = true
        },
        closeDialogCreateChat: function (){
            this.addChatDoc = null
            this.dialogCreateChat = false
        },        
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        openMainSnackBar: function (){
            this.mainSnackbar = true
        },
        closeMainSnackBar: function (){
            this.mainSnackbar = false
            this.mainSnackbarText = null
        },      
        text_truncate: function(str) {
            var length = 100;
            var ending = '...';

            if (str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str
            }
        },            
        addMessage: function (){
            if(this.currChatDoc.islinechat){
                //console.log('addMessage (islinechat) calling addLineMessage()')
                this.addLineMessage()
            }else if(this.currChatDoc.isgroupchat){
                //console.log('addMessage (isgroupchat) calling addGroupMessage()')
                this.addGroupMessage()
            }else{
                console.warn('addMessage (islinechat===false||null). doing nothing')
            }
        },
        addLineMessage: function (){
            var dt = new Date();
            var tmpdatemodified = dt.getTime()    
            var tmpchapter = this.$store.getters.member.chapter           
            var tmporg= this.$store.getters.member.org 
            var tmpmsg = this.messagetext
            var tmpchatid = this.currChatDoc.chatid
            var tmpchatname = this.currChatDoc.chatname
            var tmpparticipants = this.currChatDoc.chatparticipants
            var tmpparticipantnames = this.currChatDoc.chatparticipantnames
            var objMessage = new Object()
            objMessage.datecreated = tmpdatemodified
            objMessage.authorid = this.$store.getters.user.id
            objMessage.authorname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
            objMessage.authorlineid = this.$store.getters.member.lineid
            objMessage.authoravatar = this.$store.getters.user.photoUrl
            if(this.$store.getters.member.profilepic && this.$store.getters.member.profilepic.fileurl){
                objMessage.authoravatar = this.$store.getters.member.profilepic.fileurl
            }
            objMessage.content = tmpmsg

            var tmpChatDoc = new Object()
            tmpChatDoc.chatid = tmpchatid
            tmpChatDoc.org = tmporg
            tmpChatDoc.chapter = tmpchapter
            tmpChatDoc.participants = tmpparticipants            
            tmpChatDoc.participantnames = tmpparticipantnames
            tmpChatDoc.message = objMessage

            
            this.$store.dispatch('addLineMessage', tmpChatDoc).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addLineMessage', errmsg) 
                this.snackbarText="Failed to send message."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Message successfully sent."
                this.openSnackBar()
                this.messagetext=''
            }
            })  
            
            
        },
        addGroupMessage: function (){
            var dt = new Date();
            var tmpdatemodified = dt.getTime()    
            var tmpchapter = this.$store.getters.member.chapter           
            var tmporg= this.$store.getters.member.org 
            var tmpmsg = this.messagetext
            var tmpchatid = this.currChatDoc.chatid
            var tmpchatname = this.currChatDoc.chatname
            var tmpparticipants = this.currChatDoc.chatparticipants
            var tmpparticipantnames = this.currChatDoc.chatparticipantnames
            var objMessage = new Object()
            objMessage.datecreated = tmpdatemodified
            objMessage.authorid = this.$store.getters.user.id
            objMessage.authorname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
            objMessage.authorlineid = this.$store.getters.member.lineid
            objMessage.authoravatar = this.$store.getters.user.photoUrl
            if(this.$store.getters.member.profilepic && this.$store.getters.member.profilepic.fileurl){
                objMessage.authoravatar = this.$store.getters.member.profilepic.fileurl
            }            
            objMessage.content = tmpmsg

            var tmpChatDoc = new Object()
            tmpChatDoc.chatid = tmpchatid
            tmpChatDoc.org = tmporg
            tmpChatDoc.chapter = tmpchapter
            tmpChatDoc.participants = tmpparticipants            
            tmpChatDoc.participantnames = tmpparticipantnames
            tmpChatDoc.message = objMessage

            
            this.$store.dispatch('addGroupMessage', tmpChatDoc).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addGroupMessage', errmsg) 
                this.snackbarText="Failed to send message."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Message successfully sent."
                this.openSnackBar()
                this.messagetext=''
            }
            })  
            
            
        },
        addTaskOld: function (){
            var tmpTaskText = this.newTaskText
            var tmpTaskAssignment = this.newTaskAssignment
            if(tmpTaskText!==null && tmpTaskAssignment!==null){
                var dt = new Date();
                var tmpdatemodified = dt.getTime()    
                var tmpchatid = this.currChatDoc.chatid
                var objTask = new Object()
                objTask.chatid = tmpchatid
                objTask.org = this.$store.getters.member.org 
                objTask.datecreated = dt
                objTask.assignedto = tmpTaskAssignment
                objTask.tasktext = tmpTaskText
                objTask.isactive = true
                objTask.iscomplete = false
                objTask.createdby = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
                objTask.tags = []
                objTask.comments = []
                this.$store.dispatch('addTask', objTask).then(errmsg => {
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('addTask', errmsg) 
                    this.snackbarText="Failed to add task."
                    this.openSnackBar()
                }else{
                    //console.log('successfully added message') 
                    this.snackbarText="Task successfully added."
                    this.openSnackBar()
                    this.newTaskText = null
                    this.newTaskAssignment = null
                }
                })                  
            }else{                
                this.snackbarText="Valid task and assignment required."
                this.openSnackBar()
            }
        },
        addTask: function (){
            var tmpTaskText = this.newTaskText
            var tmpTaskAssignment = this.newTaskAssignment
            if(tmpTaskText===null || tmpTaskAssignment===null){
                    this.snackbarText="Task and assignment required."
                    this.openSnackBar()
            }else{
                var objTask = new Object()
                objTask.datecreated = new Date().getTime()
                objTask.assignedto = tmpTaskAssignment
                objTask.tasktext = tmpTaskText
                objTask.isactive = true
                objTask.iscomplete = false
                objTask.createdby = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
                objTask.tags = []
                objTask.comments = []

                var tasksUpdated = this.currChatDoc.tasks
                if(tasksUpdated===undefined || tasksUpdated===null){
                     tasksUpdated = []
                }

                tasksUpdated.push(objTask)

                var tmpPayload = new Object()
                tmpPayload.chatid = this.currChatDoc.chatid
                tmpPayload.org = this.$store.getters.member.org 
                tmpPayload.tasks = tasksUpdated

                console.log('tmpPayload',tmpPayload)
            
                this.$store.dispatch('updateTasks', tmpPayload).then(errmsg => {
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('addTask', errmsg) 
                    this.snackbarText="Failed to add task."
                    this.openSnackBar()
                }else{
                    //console.log('successfully added message') 
                    this.snackbarText="Task successfully added."
                    this.openSnackBar()
                    this.newTaskText = null
                    this.newTaskAssignment = null                 
                }
                })   
            }
          

        },        
        toggleTaskStatus: function (tsk, completeValue){
            console.log('tsk', tsk)
            console.log('completeValue', completeValue)
            var tasksUpdated = this.currChatDoc.tasks
            tasksUpdated.forEach((part, index, theArray)=>{
                if(part.tasktext===tsk.tasktext){
                    theArray[index].iscomplete=completeValue
                    theArray[index].laststatusdate= new Date().getTime()
                }
            })
            var tmpPayload = new Object()
            tmpPayload.chatid = this.currChatDoc.chatid
            tmpPayload.org = this.$store.getters.member.org 
            tmpPayload.tasks = tasksUpdated
            console.log('tmpPayload',tmpPayload)
           
            this.$store.dispatch('updateTasks', tmpPayload).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('toggleTaskStatus', errmsg) 
                this.snackbarText="Failed to update task."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Task successfully updated."
                this.openSnackBar()
                this.newTaskText = null
                this.newTaskAssignment = null
            }
            })             

        },
        addTaskComment: function (tsk){
            console.log('tsk', tsk)
            console.log('comment', this.newTaskComment)
            var comment = this.newTaskComment
            if(comment===null){
                    this.snackbarText="Comment text required."
                    this.openSnackBar()
            }else{
                var authorname = this.member.firstname + ' ' + this.member.lastname
                var tmpdatecreated = new Date().getTime()
                var tasksUpdated = this.currChatDoc.tasks
                tasksUpdated.forEach((part, index, theArray)=>{
                    if(part.tasktext===tsk.tasktext){
                        if(part.comments ===undefined || part.comments===null){
                            theArray[index].comments=[]
                        }
                        theArray[index].comments.push({authorname: authorname, comment: comment, datecreated: tmpdatecreated})
                    }
                })
                var tmpPayload = new Object()
                tmpPayload.chatid = this.currChatDoc.chatid
                tmpPayload.org = this.$store.getters.member.org 
                tmpPayload.tasks = tasksUpdated
                //console.log('tmpPayload',tmpPayload)
            
                this.$store.dispatch('updateTasks', tmpPayload).then(errmsg => {
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('addTaskComment', errmsg) 
                    this.snackbarText="Failed to update task."
                    this.openSnackBar()
                }else{
                    //console.log('successfully added message') 
                    this.snackbarText="Task successfully updated."
                    this.openSnackBar()
                    this.newTaskComment= null                    
                }
                })   
            }
          

        },
        promptAddParticipants: function(){
            this.dialogAddParticipants = true
        },
        addNewParticipants: function(){
            var arrNewParticipants = this.addParticipants
            console.log('arrNewParticipants',arrNewParticipants)

            if(arrNewParticipants && arrNewParticipants.length && arrNewParticipants.length>0){
                arrNewParticipants.forEach(p=>{
                    if(this.currChatDoc.participantnames===undefined || this.currChatDoc.participantnames===null){
                        this.currChatDoc.participantnames = []
                    }
                    if(this.currChatDoc.participants===undefined || this.currChatDoc.participants===null){
                        this.currChatDoc.participants = []
                    }                     
                    this.currChatDoc.participantnames.push(p.firstname + ' ' + p.lastname)
                    this.currChatDoc.participants.push(p.userid)
                })
            }

            console.log('this.currChatDoc.participantnames',this.currChatDoc.participantnames,'this.currChatDoc.participants',this.currChatDoc.participants )
            if(this.currChatDoc.participants.length>0 && this.currChatDoc.participantnames.length>0){
               

                var tmpPayload = new Object()
                tmpPayload.chatid = this.currChatDoc.chatid
                tmpPayload.org = this.$store.getters.member.org 
                tmpPayload.participants = this.currChatDoc.participants
                tmpPayload.participantnames = this.currChatDoc.participantnames
                console.log('tmpPayload',tmpPayload)    

                //update chat participants & participantnames in db
                this.$store.dispatch('updateParticipants', tmpPayload).then(errmsg => {
                //console.log('msg', errmsg)
                if(errmsg && errmsg ==='failure'){
                    console.error('addNewParticipants', errmsg) 
                    this.snackbarText="Failed to update participants."
                    this.openSnackBar()
                }else{
                    //console.log('successfully added message') 
                    this.snackbarText="Participants successfully updated."
                    this.openSnackBar()
                    this.newTaskComment= null                    
                }
                })                
                
            }

            this.dialogAddParticipants = false
        },
        promptDeleteParticipant: function(pname){
            this.deleteParticipantName=pname
            var deleteParticipantObjs = this.allMembers.find(m=>{return m.firstname + ' ' + m.lastname ===pname})
            if(deleteParticipantObjs){

                if(this.deleteParticipantIds===null){
                    this.deleteParticipantIds = []
                }
                this.deleteParticipantIds.push(deleteParticipantObjs.userid)
            }
              
            //console.log('this.deleteParticipantName',this.deleteParticipantName,'this.deleteParticipantIds=',this.deleteParticipantIds)
            this.dialogDeleteParticipant = true
        },
        deleteParticipant: function (){
            var indPname = this.currChatDoc.participantnames.indexOf(this.deleteParticipantName)
            if(indPname>-1){
                this.currChatDoc.participantnames.splice(indPname,1)
            }

            if(this.deleteParticipantIds && this.deleteParticipantIds.length && this.deleteParticipantIds.length>0){
                this.deleteParticipantIds.forEach(pid=>{
                    var indPid = this.currChatDoc.participants.indexOf(pid)
                    this.currChatDoc.participants.splice(indPid,1)
                })
            }

            var tmpPayload = new Object()
            tmpPayload.chatid = this.currChatDoc.chatid
            tmpPayload.org = this.$store.getters.member.org 
            tmpPayload.participants = this.currChatDoc.participants
            tmpPayload.participantnames = this.currChatDoc.participantnames
            console.log('tmpPayload',tmpPayload)

            //update chat participants & participantnames in db
            this.$store.dispatch('updateParticipants', tmpPayload).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('updateParticipants', errmsg) 
                this.snackbarText="Failed to update participants."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Participants successfully updated."
                this.openSnackBar()
                this.newTaskComment= null                    
            }
            })
            this.dialogDeleteParticipant = false
             this.deleteParticipantName = null
             this.deleteParticipantIds = null
        }                             
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}

.convo-card{
  border-radius:15px;
 
}


.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}

.chat-card-date{
    text-align: left;
    margin-right:15px;
    color:dimgrey;
}

.chat-card-me {
	position: relative;
	background: #DCDCDC;
	border-radius: .4em;
}

.chat-card-me:after {
	content: '';
	position: absolute;
	left: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
	border-right-color: #DCDCDC;
	border-left: 0;
	border-bottom: 0;
	margin-top: -10px;
	margin-left: -20px;
}

.chat-card {
	position: relative;
	background: #DCDCDC;
	border-radius: .4em;
}

.chat-card:after {
	content: '';
	position: absolute;
	right: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
	border-left-color: #DCDCDC;
	border-right: 0;
	border-bottom: 0;
	margin-top: -10px;
	margin-right: -20px;
}
</style>